import { createFileRoute, redirect } from "@tanstack/react-router";
import SignUp from "../pages/SignUp";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/sign-up")({
  head: () => pageHead("page.signUp"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    if (context.auth?.user) {
      throw redirect({ to: "/" });
    }
  },
  component: SignUpPage,
});

function SignUpPage() {
  return <SignUp />;
}
